import React from 'react';
import PropTypes from "prop-types";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import axios from "axios";

class ComponentAttachmentsTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);
    }

    render() {
        const attachments = this.props.tab.config.attachments;
        return (
            <div className="feature-details-component-attachments">
                {attachments && (
                    <div>
                        {attachments.map(a => this.renderAttachment(a))}
                    </div>
                )}
            </div>
        );
    }

    downloadAttachment(attachment, url) {
        axios(url, {responseType: 'blob'}).then(response => {
            const blob = new Blob([response.data], {type: attachment.mime_type});
            const objectUrl = URL.createObjectURL(blob);
            this.downloadFile(attachment.name, objectUrl);
        }).catch(error => {
            console.log("Error *** : " + error);
        });

    }

    renderAttachment(a) {
        let downloadUrl = null;
        if (a.links && a.links.length) {
            a.links.forEach(l => {
                if (l.rel == 'download') {
                    downloadUrl = l.href;
                }
            });
        }
        return (
            <div key={a.name + downloadUrl}>
                <img src={"data:image/png;base64," + a.previewBase64content}/>
                {downloadUrl ? (
                    <span><a onClick={() => this.downloadAttachment(a, downloadUrl)}>{a.name}</a></span>
                ) : (
                    <span>{a.name}</span>
                )}
            </div>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(ComponentAttachmentsTab);
